import { apiRequest } from "./common";

const getAllSubject = async (pageNo, pageSize, type, grade) => {
    const response = await apiRequest('get', `/subject?page=${pageNo}&limit=${pageSize}&type=${type}&grade=${grade}`);
    return response.data;
};

const assignSubject = async (data) => {
    const response = await apiRequest('post', `/subject/assign`, data);
    return response.data;
};

const getAllAssignSubject = async (type, studentId) => {
    const response = await apiRequest('get', `/subject/by-student?type=${type}&studentId=${studentId}`);
    return response.data;
};

export {
    getAllSubject,
    assignSubject,
    getAllAssignSubject
}